import { motion } from "framer-motion";
import {
  Lightbulb, Cable, PlugZap, ShieldCheck, Home, Bell, Fan, Wrench,
} from "lucide-react";

const services = [
  { icon: Cable, title: "Full & Partial Rewiring", desc: "Modern, safe wiring for older properties and extensions.", span: "lg:col-span-8", big: true },
  { icon: PlugZap, title: "EV Charger Installation", desc: "Home charge points, fully certified.", span: "lg:col-span-4" },
  { icon: ShieldCheck, title: "Consumer Units & Fuse Boards", desc: "Upgrades to the latest 18th edition boards.", span: "lg:col-span-4" },
  { icon: Lightbulb, title: "Lighting Design & Install", desc: "Indoor, outdoor, LED and smart lighting.", span: "lg:col-span-4" },
  { icon: Bell, title: "Fault Finding & Repairs", desc: "Fast diagnosis of tripping and faults.", span: "lg:col-span-4" },
  { icon: Home, title: "Sockets & Additions", desc: "Extra sockets, USB points and outdoor supplies.", span: "lg:col-span-5" },
  { icon: ShieldCheck, title: "EICR & Safety Testing", desc: "Landlord certificates and inspection reports.", span: "lg:col-span-4" },
  { icon: Fan, title: "Air Con Servicing", desc: "Install, maintain and repair all major brands.", span: "lg:col-span-3" },
];

const cardVariant = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Services = () => {
  return (
    <section id="electrical" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-brand-yellow mb-4">
              02 — What we do
            </p>
            <h2 className="font-display font-extrabold tracking-tighter text-ink text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
              Electrical services, done properly.
            </h2>
          </div>
          <p className="font-body text-ink/55 max-w-sm text-lg leading-relaxed">
            From a single socket to a full rewire — every job is planned, certified and left spotless.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                custom={i}
                variants={cardVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`service-card-${i}`}
                className={`group ${s.span} rounded-2xl border border-black/10 bg-white p-7 hover:border-brand-yellow transition-colors duration-300 ${
                  s.big ? "lg:row-span-1 min-h-[220px] flex flex-col justify-between" : ""
                }`}
              >
                <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-cloud border border-black/5 group-hover:bg-brand-yellow transition-colors duration-300">
                  <Icon size={22} className="text-ink" />
                </div>
                <div className={s.big ? "mt-8" : "mt-6"}>
                  <h3 className={`font-display font-bold tracking-tight text-ink ${s.big ? "text-3xl" : "text-xl"}`}>
                    {s.title}
                  </h3>
                  <p className="font-body text-ink/55 mt-2 leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
